import { render, staticRenderFns } from "./ActiveTelegramModal.vue?vue&type=template&id=1d6531b6"
import script from "./ActiveTelegramModal.vue?vue&type=script&lang=js"
export * from "./ActiveTelegramModal.vue?vue&type=script&lang=js"
import style0 from "./ActiveTelegramModal.vue?vue&type=style&index=0&id=1d6531b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports